import {Injectable, signal} from '@angular/core';
import {AccountInfo} from '@azure/msal-browser';
import {UserSessionData} from '../models/output.model';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  //ctm =  { username: "ctm@static.env", name: "Static" } as UserSessionData

  private readonly _username = signal<AccountInfo | null>(null);
  //private readonly _username = signal<AccountInfo | null>(null);

  public readonly username = this._username.asReadonly();

  public setUsername(username: AccountInfo | null): void {
    this._username.set(username);
  }

  public getUser(): AccountInfo | null {
    return this._username();
  }

  public clearUsername(): void {
    this._username.set(null);
  }

}
